import React from 'react'
import Link from 'gatsby-link'
import axios from 'axios'
import Api from '../api'
import Header from '../components/Header'

const API_KEY = 'KFqesOswI5dWP5d'
const api = new Api(API_KEY)

String.prototype.replaceAll = function(search, replacement) {
  var target = this
  return target.split(search).join(replacement)
}

class NewsPage extends React.Component {
  state = {
    isLoading: true,
    isDetail: false,
    currentLimit: 0,
    articles: [],
    article: null,
  }

  componentDidMount() {
    if (window.location.search.includes('article_key')) {
      this.setState({
        isDetail: true,
      })

      this.loadArticle(window.location.search.substr('?article_key='.length))
    } else {
      this.setState({
        isDetail: false,
      })
      this.loadMoreArticles()
    }
  }

  loadArticle = key => {
    this.setState({
      isLoading: true,
    })
    api.getArticle(key).then(response => {
      console.log(response.data)
      this.setState({
        article: response.data,
        isLoading: false,
      })
    })
  }

  loadMoreArticles = () => {
    this.setState({
      isLoading: true,
    })
    api.listArticles(10, this.state.currentLimit).then(response => {
      console.log(response.data)
      this.setState({
        articles: [...this.state.articles, ...response.data],
        currentLimit: this.state.currentLimit + 10,
        isLoading: false,
      })
    })
  }

  renderList = () => {
    const { articles = [] } = this.state

    return (
      <div>
        {articles.map(article => {
          const url = `${window.location.origin}/nieuws?article_key=${
            article.article_key
          }`
          return (
            <a key={article.id} href={url} className="ListArticle">
              <figure className="ListArticle-figure">
                <img src={article.afbeelding_image_url} />
              </figure>
              <div className="ListArticle-content">
                <h2>{article.title}</h2>
                <p>{article.intro}</p>
              </div>
            </a>
          )
        })}
        <div className="ArticeListFooter">
          {this.state.isLoading ? (
            'Laden...'
          ) : (
            <button className="Button" onClick={this.loadMoreArticles}>
              Laad meer
            </button>
          )}
        </div>
      </div>
    )
  }

  renderArticle = () => {
    const { article, isLoading } = this.state

    if (isLoading) return <div className="ArticeListFooter">Laden...</div>
    return (
      <div>
        <article className="Article">
          <div
            className="Content"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />
        </article>
        <div className="ArticeListFooter">
          <a className="Button" href="/nieuws">
            Terug naar Nieuws
          </a>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <Header />
        <div className="inner">
          {this.state.isDetail ? this.renderArticle() : this.renderList()}
        </div>
      </div>
    )
  }
}

export default NewsPage



// WEBPACK FOOTER //
// ./src/pages/nieuws.js